module.exports = __webpack_public_path__ + "assets/1d2e31441bbbfd0d1310e44eb1beaaa9.png";